const $inject = [];

const lbTripOptionsCarFormItem = {
  controller: 'lbTripOptionsCarFormItemCtrl as vm',
  template: require('./lbTripOptionsCarFormItem.html'),
  bindings: {
    search: '<',
    isLast: '<',
    index: '<'
  }
};

lbTripOptionsCarFormItem.$inject = $inject;

export default lbTripOptionsCarFormItem;




// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsCarFormItem.js